module.exports = __webpack_public_path__ + "img/icon_phone.0511e604.png";